import labelBaseTpl from './base';

const labelTpl = `label`

export { labelTpl }